/*
  Pabau enquiry form (snippets/pabau-form.liquid), on every placement.

  Sends the enquiry as JSON to OUR server (Theme settings, Clinic booking,
  Enquiry server: clinic-capture/api/enquiry.js), which creates the Pabau lead
  and the Shopify copy and answers with the Pabau lead id. The browser never
  talks to Pabau. REQUIREMENTS, Clinic / booking, "Booking journeys and
  tracking, 2 Oct", point 7.

  On the server's yes:
    - the conversion, once: while "Send conversions directly" is on, the
      live hand-off (`localStorage.dataLayerDetails`, live's key and shape,
      which assets/tracking.js pushes for GTM on the next page, plus the new
      parameters beside it); with it off, pabau_form_submitted is pushed here.
      event_id is the Pabau lead id;
    - AttributionTracker.submit, as live;
    - then /pages/thank-you.
  On a no, or no answer: an error with the clinic phone numbers and emails,
  enquiry_form_error with the reason, no conversion, no redirect.

  Pre-selects the treatment and clinic from ?treatment=<handle> and
  ?clinic=<value or clinic page handle>, else from the page's own context.
*/
(function () {
  if (window.__pabauFormBound) return;
  window.__pabauFormBound = true;

  var TIMEOUT_MS = 30000;

  function T() { return window.DDJTrack || null; }

  function track(event, params) {
    var t = T();
    if (t) t.track(event, params);
    else (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: event }, params));
  }

  function context() {
    return (window.DDJTracking && window.DDJTracking.context) || {};
  }

  function userId() {
    var t = T();
    if (t) return t.userId();
    return window.pabauUserId || '';
  }

  /* Live's own formatting for the GA4 values (pabaul-london.liquid). */
  function formatValue(value) {
    if (!value || value === 'Not Provided') return 'Not Provided';
    return String(value).toLowerCase().replace(/\s+/g, '_');
  }

  /* ─── Pre-selection ──────────────────────────────────────────────────── */

  function selectBy(select, test) {
    if (!select) return false;
    for (var i = 0; i < select.options.length; i++) {
      var o = select.options[i];
      if (o.value && test(o)) { select.value = o.value; return true; }
    }
    return false;
  }

  function prefill(form) {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (e) { params = null; }
    var ctx = context();

    var tSelect = form.querySelector('[data-pabau-treatment]');
    var tWanted = (params && params.get('treatment')) || (ctx.treatment && ctx.treatment.handle) || '';
    if (tWanted) {
      var key = tWanted.toLowerCase();
      selectBy(tSelect, function (o) { return (o.getAttribute('data-handle') || '').toLowerCase() === key; }) ||
        selectBy(tSelect, function (o) { return o.value.toLowerCase() === key; });
    }

    var cSelect = form.querySelector('[data-pabau-clinic]');
    var cWanted = (params && params.get('clinic')) || (ctx.clinic && ctx.clinic.value) || '';
    if (cWanted) {
      var ckey = cWanted.toLowerCase().trim();
      selectBy(cSelect, function (o) { return o.value.toLowerCase() === ckey; }) ||
        selectBy(cSelect, function (o) { return (o.getAttribute('data-page') || '').toLowerCase() === ckey; }) ||
        selectBy(cSelect, function (o) { return o.value.toLowerCase().indexOf(ckey) === 0; });
    }
  }

  /* ─── Messages ───────────────────────────────────────────────────────── */

  var CONTACT_HTML =
    '<span class="block">London: <a class="underline" href="tel:+442075896309">0207 589 6309</a>'
    + ' or <a class="underline" href="mailto:clinic@drdavidjack.com">clinic@drdavidjack.com</a></span>'
    + '<span class="block">Edinburgh: <a class="underline" href="tel:01315568178">013 1556 8178</a>'
    + ' or <a class="underline" href="mailto:edinburgh@drdavidjack.com">edinburgh@drdavidjack.com</a></span>';

  function showError(form) {
    var box = form.querySelector('[data-pabau-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-pabau-error', '');
      box.setAttribute('role', 'alert');
      box.className = 'body-base col-span-2 flex flex-col gap-stack border border-red p-3 text-red';
      var actions = form.querySelector('[data-pabau-actions]');
      form.insertBefore(box, actions || null);
    }
    box.innerHTML = '<strong class="font-medium">Sorry, we could not send your enquiry.</strong>'
      + '<span>Nothing has been booked. Please try again in a moment, or contact the clinic team directly:</span>'
      + CONTACT_HTML;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setBusy(form, busy) {
    var button = form.querySelector('[data-pabau-submit]');
    if (!button) return;
    var label = button.querySelector('span') || button;
    if (busy) {
      if (!button.hasAttribute('data-label')) button.setAttribute('data-label', label.textContent);
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      label.textContent = 'Sending';
    } else {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = button.getAttribute('data-label') || label.textContent;
    }
  }

  /* ─── Submit ─────────────────────────────────────────────────────────── */

  /* Attribution is a nice-to-have: anything that goes wrong reading it
   * (storage blocked, tracking.js missing) sends the enquiry without it. */
  function safeAttribution() {
    var t = T();
    if (!t || typeof t.attribution !== 'function') return {};
    try { return t.attribution() || {}; } catch (e) { return {}; }
  }

  function safeUserId() {
    try { return userId(); } catch (e) { return window.pabauUserId || ''; }
  }

  /* bare: leave out everything tracking.js supplies, the fallback when
   * building the full payload throws. */
  function payloadFor(form, bare) {
    var data = new FormData(form);
    return {
      firstName: data.get('Fname') || '',
      lastName: data.get('Lname') || '',
      email: data.get('email') || '',
      phone: data.get('mobile') || '',
      dob: data.get('dob') || '',
      treatment: data.get('custom_field_96855') || '',
      clinic: data.get('custom_field_96868') || '',
      leadSource: data.get('lead_source') || '',
      treatmentDate: data.get('custom_field_171698') || '',
      comments: data.get('custom_field_171700') || '',
      emailConsent: !!form.querySelector('input[name="checkbox[]"]:checked'),
      smsConsent: !!form.querySelector('input[name="checkbox-1[]"]:checked'),
      userId: bare ? (window.pabauUserId || '') : safeUserId(),
      practitioner: form.getAttribute('data-practitioner') || '',
      formName: form.getAttribute('data-form-name') || 'london_booking_form',
      pageUrl: window.location.href.split('#')[0],
      attribution: bare ? {} : safeAttribution(),
      hp: data.get('hp') || ''
    };
  }

  function convert(form, payload, leadId) {
    var direct = !!(window.DDJTracking && window.DDJTracking.direct);
    var uid = payload.userId;
    var treatment = formatValue(payload.treatment || 'Not Provided');
    var clinic = formatValue(payload.clinic || 'Not Provided');
    var leadSource = formatValue(payload.leadSource || 'Not Provided');

    if (direct) {
      /* Live's hand-off, same key and shape (pabaul-london.liquid). */
      try {
        localStorage.setItem('dataLayerDetails', JSON.stringify({
          event: 'pabau_form_submitted',
          userId: uid,
          treatment: [treatment],
          clinic: [clinic],
          leadSource: leadSource,
          formName: payload.formName
        }));
        localStorage.setItem('ddj_enquiry_extra', JSON.stringify({
          event_id: leadId,
          practitioner: payload.practitioner,
          pabau_user_id: uid
        }));
      } catch (e) { /* storage blocked: nothing more we can do */ }
    } else {
      track('pabau_form_submitted', {
        event_id: leadId,
        treatment: treatment,
        clinic: clinic,
        leadSource: leadSource,
        formName: payload.formName,
        practitioner: payload.practitioner,
        pabau_user_id: uid
      });
    }

    var t = T();
    if (t) t.attributionSubmit();
  }

  function fail(form, payload, reason) {
    form.removeAttribute('data-sending');
    setBusy(form, false);
    showError(form);
    var name = (payload && payload.formName) || form.getAttribute('data-form-name') || 'london_booking_form';
    try { track('enquiry_form_error', { reason: reason, form_name: name, formName: name }); } catch (e) { /* the message is up; tracking is optional */ }
  }

  /* Back from the thank-you page (restored from the browser's cache): the
   * form comes back as it was left, still sending. Free it. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-pabau-form][data-sending="true"]').forEach(function (form) {
      form.removeAttribute('data-sending');
      setBusy(form, false);
    });
    syncDates();
  });

  /* Past preventDefault the browser will not send the form, so nothing in
   * here may die quietly: any error shows the red box (script_error). */
  function onSubmit(event) {
    var form = event.target.closest && event.target.closest('[data-pabau-form]');
    if (!form) return;
    event.preventDefault();
    if (form.getAttribute('data-sending') === 'true') return;
    try {
      send(form);
    } catch (e) {
      fail(form, null, 'script_error');
    }
  }

  function send(form) {
    var old = form.querySelector('[data-pabau-error]');
    if (old) old.remove();

    var endpoint = form.getAttribute('data-endpoint');
    var payload;
    try { payload = payloadFor(form); } catch (e) { payload = payloadFor(form, true); }
    if (!endpoint) { fail(form, payload, 'no_endpoint'); return; }

    form.setAttribute('data-sending', 'true');
    setBusy(form, true);

    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, TIMEOUT_MS);

    fetch(endpoint, {
      method: 'POST',
      /* text/plain keeps it a CORS-simple request (no preflight); the
       * server parses the JSON either way. */
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: JSON.stringify(payload),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (body) {
        return { status: res.status, body: body };
      });
    }).then(function (answer) {
      clearTimeout(timer);
      form.removeAttribute('data-sending');
      var body = answer.body || {};
      if (answer.status >= 200 && answer.status < 300 && body.ok === true) {
        /* The lead is in: a tracking error must not stop the thank-you page. */
        try {
          if (!payload.hp) convert(form, payload, body.leadId ? String(body.leadId) : '');
        } catch (e) { /* ignore */ }
        window.location.href = form.getAttribute('data-redirect') || '/pages/thank-you';
        return;
      }
      var reason = body.error ? String(body.error) : 'http_' + answer.status;
      if (body.error === 'pabau') reason = body.saved ? 'pabau_refused_saved' : 'pabau_refused';
      fail(form, payload, reason);
    }, function (err) {
      clearTimeout(timer);
      form.removeAttribute('data-sending');
      fail(form, payload, err && err.name === 'AbortError' ? 'timeout' : 'network');
    });
  }

  /* ─── Empty date boxes ───────────────────────────────────────────────── */

  /* WebKit (every iPhone browser) paints today's date into an EMPTY date
   * input and ignores the ::-webkit-datetime-edit rules, so an empty required
   * box looked filled. `is-empty` on the box (.form-input--date, rendered on
   * by the snippet) hides the input's text while it has no value and is not
   * in use; the label stays. A half-typed date (badInput) counts as filled,
   * so what the visitor typed is never hidden. */
  function syncDate(input) {
    var box = input.closest && input.closest('.form-input--date');
    if (!box) return;
    var empty = !input.value && !(input.validity && input.validity.badInput);
    box.classList.toggle('is-empty', empty);
  }

  function syncDates() {
    document.querySelectorAll('.form-input--date input[type="date"]').forEach(syncDate);
  }

  function onDateEdit(event) {
    var t = event.target;
    if (t && t.type === 'date') syncDate(t);
  }

  /* ─── Start ──────────────────────────────────────────────────────────── */

  function onFirstTouch(event) {
    var form = event.target.closest && event.target.closest('[data-pabau-form]');
    if (!form || form.hasAttribute('data-started')) return;
    form.setAttribute('data-started', '');
    track('enquiry_form_start', { form_name: form.getAttribute('data-form-name') || 'london_booking_form' });
  }

  function init() {
    document.querySelectorAll('[data-pabau-form]').forEach(function (form) {
      if (form.hasAttribute('data-ready')) return;
      form.setAttribute('data-ready', '');
      prefill(form);
    });
    syncDates();
  }

  document.addEventListener('submit', onSubmit);
  document.addEventListener('focusin', onFirstTouch);
  document.addEventListener('input', onDateEdit);
  document.addEventListener('change', onDateEdit);
  document.addEventListener('focusout', onDateEdit);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
